import HelocCalculatorHomeValue from './HelocCalculatorHomeValue'
import { useHeloc } from './HelocContext'
import { useTriggerEvents } from '@/hooks/useTriggerEvents'

export const HomeValue = ({ helocUpdated }) => {
  const { dispatch } = useHeloc()
  const { fireAndForget } = useTriggerEvents()

  const defaultValues = {
    minimumHomesCurrentValue: 0,
    maximumHomesCurrentValue: 10000000000,
    minimumMortgageOutstandingBalance: 0,
    maximumMortgageOutstandingBalance: 10000000000,
    minimumDesiredLoanAmount: 0,
    maximumDesiredLoanAmount: 10000000000,
    homesCurrentValueInfo:
      "This is the current value of your home. You can get this from an appraiser, real estate broker, or by searching online for what's my home worth? and providing your address.",
    mortgageOutstandingBalanceInfo:
      'Most lenders require you to have at least 20% equity in your home to qualify for home equity financing.',
    desiredLoanAmountInfo:
      'How much would you like to borrow? Most home equity lenders allow you to borrow up to 80% of your property value including your first mortgage balance. The loan to value requirement can vary with each lender.',
    creditScoreInfo:
      'Lenders generally require a credit score of at least 620, and sometimes higher, to approve home equity financing.',
    selectItemList: [
      { label: 'Excellent (750+)', value: 'excellent' },
      { label: 'Good (680 - 749)', value: 'good' },
      { label: 'Average (620 - 679)', value: 'average' },
      { label: 'Below Average (<620)', value: 'below average' },
    ],
  }

  const parseValue = (value) => {
    return parseFloat(value.replace(/[^0-9.-]+/g, '')) || 0
  }

  const validateNumericInput = (value, fieldName) => {
    const numValue = parseValue(value)
    const minValue = defaultValues[`minimum${fieldName}`]
    const maxValue = defaultValues[`maximum${fieldName}`]

    if (numValue < minValue) return minValue
    if (maxValue > 0 && numValue > maxValue) return maxValue

    const intValue = value.replaceAll('$', '').replaceAll(',', '')

    if (fieldName === 'DesiredLoanAmount') {
      if (numValue > 300000) {
        fireAndForget({
          event_type: 'heloc_calc_field_input',
          field_name: fieldName,
          value: intValue,
          valid: 'false',
        })
        dispatch({ type: 'SET_LOAN_AMOUNT_ERROR', payload: true })
        dispatch({
          type: 'SET_LOAN_AMOUNT_ERROR_MESSAGE',
          payload: 'Your amount exceeds our limit, which is $300,000',
        })
      } else if (numValue < 15000) {
        fireAndForget({
          event_type: 'heloc_calc_field_input',
          field_name: fieldName,
          value: intValue,
          valid: 'false',
        })
        dispatch({ type: 'SET_LOAN_AMOUNT_ERROR', payload: true })
        dispatch({
          type: 'SET_LOAN_AMOUNT_ERROR_MESSAGE',
          payload: 'Your amount is below our minimum limit, which is $15,000',
        })
      } else {
        fireAndForget({
          event_type: 'heloc_calc_field_input',
          field_name: fieldName,
          value: intValue,
          valid: 'true',
        })
        dispatch({ type: 'SET_LOAN_AMOUNT_ERROR', payload: false })
        dispatch({ type: 'SET_LOAN_AMOUNT_ERROR_MESSAGE', payload: '' })
      }
    }

    return numValue
  }

  return (
    <HelocCalculatorHomeValue
      onSetHomeValue={({ addressValue, addressState }) => {
        if (addressValue) {
          dispatch({
            type: 'SET_HOMES_CURRENT_VALUE',
            payload: validateNumericInput(addressValue, 'HomesCurrentValue'),
          })
          dispatch({ type: 'SET_LIVE_STATE', payload: addressState })
          window.scrollTo({ top: 0, behavior: 'smooth' })
        }
      }}
      helocUpdated={helocUpdated}
    />
  )
}
